<pp-modal>
  <ng-container heading>
    {{ 'activity' | ppTranslate }}

    <img [src]="icon" (click)="toggleSettings()" />
  </ng-container>

  <ng-container body>
    @if (!dashletSettingsVisible) {
      <div class="dashletModal__body-container" #dashletActivities>
        @if (activities.length === 0 && fetched) {
          <div class="alert alert-info">
            {{ 'no_recent_activity' | ppTranslate }}
          </div>
        }
        @if (activities.length > 0 && fetched) {
          <ul class="dashletActivities__ul">
            @for (activity of activities; track activity; let i = $index) {
              <pp-dashlet-activity
                [ppActivity]="activity"
                [ppAllUsers]="allUsers"
                [ppWorkspaces]="workspaces"
              ></pp-dashlet-activity>
            }
            @if (ppLoading) {
              <pp-spinner [ppDashboard]="true"></pp-spinner>
            }
          </ul>
        } @else {
          @if (!fetched) {
            <pp-dashlet-activities-placeholder></pp-dashlet-activities-placeholder>
          }
        }
        @if (!allActivitiesLoaded && !ppLoading) {
          <pp-button
            ppStyle="primary"
            ppId="loadMoreActivitiesButton"
            (ppAction)="fetchActivities()"
          >
            {{ 'load_more' | ppTranslate }}
          </pp-button>
        }
      </div>
    }

    @if (dashletSettingsVisible) {
      <pp-activities-dashlet-modal-settings
        (ppSelectSiteRange)="selectSiteRange($event)"
        [ppDashlet]="dashlet"
      >
      </pp-activities-dashlet-modal-settings>
    }
  </ng-container>

  <ng-container footer>
    <!-- TODO Footer component -->
    @if (dashletSettingsVisible) {
      <pp-delete-button (ppAction)="removeDashlet()"></pp-delete-button>
    }

    @if (dashletSettingsVisible) {
      <pp-button
        data-m-target="Dashlet settings apply button"
        ppStyle="primary"
        (ppAction)="apply()"
        ppSize="small"
      >
        <i class="fas fa-check" aria-hidden="true"></i>
        {{ 'apply' | ppTranslate }}
      </pp-button>
    }
  </ng-container>
</pp-modal>
